import { render, staticRenderFns } from "./OrganizerListItem.vue?vue&type=template&id=7e83bc58&scoped=true&"
import script from "./OrganizerListItem.vue?vue&type=script&lang=js&"
export * from "./OrganizerListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerListItem.vue?vue&type=style&index=0&id=7e83bc58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e83bc58",
  null
  
)

export default component.exports